import React from "react";
import Header from "../components/FrontPage/Header/Header";
import Footer from "../components/Footer/Footer";
import LeftDrawer from "../components/Dashboard/Drawers/LeftDrawer";
import CMR from "./static/CMR";
import ScrollToTopOnMount from "../helpers/ScrollToTop";

const CMRPage = ({ USER }) => {
  return (
    <>
      <ScrollToTopOnMount />
      <Header />
      <CMR />
      <Footer />
      {USER && <LeftDrawer small />}
    </>
  );
};

export default CMRPage;
